<template>
  <div style="padding-left: 10px;padding-right: 10px;min-width: 200px;max-width: 300px;max-height: 250px;overflow: auto">
    <div class="col-xs-12">
      <span class="">Filter By Expert Type</span>
    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div class="row">
        <div class="col-xs-6">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="feedFilter"> Select All</a>
        </div>
        <div class="col-xs-6 text-right">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="clearFilter"> Clear All</a>
        </div>
      </div>
    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div v-for="(expertSource, key) in expertSources" v-if="expertSource"  :key="key" style="padding-top: 10px">
        <div class="checkbox checkbox-info checkbox-inline" v-if="expertSource.name !== 'nonJSI'">
          <template v-if="expertSource.name === null">
            <input :id="uniqId + 'checkbox-expertSource-all'" type="checkbox" v-on:change="expertSourceSelected(expertSource)"
                   v-bind:checked="checked(expertSource)" :disabled="expertSource.nb === 0">
            <label :for="uniqId + 'checkbox-expertSource-all'"> Rest of the world ({{expertSource.nb}})</label>
          </template>
          <template v-else>
            <input :id="uniqId + 'checkbox-expertSource-' + expertSource.name" type="checkbox"
                   v-on:change="expertSourceSelected(expertSource)" v-bind:checked="checked(expertSource)"
                   :disabled="expertSource.nb === 0">
            <label :for="uniqId + 'checkbox-expertSource-' + expertSource.name" class="text-capitalize">
              <template v-if="expertSource.name === 'TECHNICAL EDISON' ">EDISON ({{expertSource.nb}})</template>
              <template v-else>{{expertSource.name}} ({{expertSource.nb}})</template>
            </label>

          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .pe-ul > li {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pe-ul > li > i{
    color: #62cb31;
    font-weight: bold;
  }

  .pe-ul > li > span{
    font-size: 14px;
    font-weight: normal;
  }

</style>
<script>

export default {
  components: {},
  props: ['expertSources', 'expertSourcesSelected'],
  name: 'ExpertSourceBox',
  data () {
    return {
      uniqId: ''
    }
  },
  methods: {
    checked: function (expertSource) {
      if (this.expertSourcesSelected.length !== 0) {
        let tmpExpertSourceSelected = this.expertSourcesSelected.find((expertSourceSelected) => {
          return expertSourceSelected.name === expertSource.name
        })
        if (typeof tmpExpertSourceSelected !== 'undefined') {
          return true
        }
      }
      return false
    },
    expertSourceSelected: function (expertSource) {
      let index = this.expertSourcesSelected.map((e) => {
        return e.name
      }).indexOf(expertSource.name)

      if (index === -1) {
        this.expertSourcesSelected.push(expertSource)
      } else {
        this.expertSourcesSelected.splice(index, 1)
      }
    },
    clearFilter: function (event) {
      this.expertSourcesSelected.splice(0, this.expertSourcesSelected.length)
      event.preventDefault()
    },
    feedFilter: function (event) {
      this.clearFilter(event)

      this.expertSources.forEach((expertSource) => {
        this.expertSourcesSelected.push(expertSource)
      })
      event.preventDefault()
    }
  },
  beforeMount () {
    this.uniqId = Math.random().toString()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/ExpertSourceBox.vue